import { render } from "./AccountingTemplatesUpdate.vue?vue&type=template&id=15c5ec09"
import script from "./AccountingTemplatesUpdate.vue?vue&type=script&lang=js"
export * from "./AccountingTemplatesUpdate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__